const PAGE_SIZE_OPTIONS = [10,20,30,50,100,200];

export const DEFAULT_PAGING = {
  stateTextVisible: true,
  pageSizeVisible: false,
  pageIndexVisible: false,
  jumpVisible: false,
  endJumpVisible: false,
  pageSizeOptions: PAGE_SIZE_OPTIONS,
};
